export default __webpack_public_path__ + "static/media/c002-PPII-2.cb90b9b5.svg";